import React from 'react';
import styled from 'styled-components/macro';

const SLayout = styled.div`
    font-size: 16px;
    font-weight: bold;
`;

const TextHeader = ({ children, className, style, underline, italic }) => {
    return (
        <SLayout
            className={className}
            style={{
                textDecoration: underline ? 'underline' : 'none',
                fontStyle: italic ? 'italic' : 'normal',
                ...style,
            }}
        >
            {children}
        </SLayout>
    );
};

export default TextHeader;
